export default "__VITE_ASSET__CTM$kMGZ__"